import React from 'react';
import classNames from 'classnames';
import { bool, func, string, number } from 'prop-types';
import { Form as FinalForm } from 'react-final-form';

import { intlShape, injectIntl } from '../../util/reactIntl';
import { Button, Form, IconCard, NamedLink, PaginationLinks, ResponsiveImage } from '../../components';

import css from './FollowCompanyForm.module.css';
import userImage from '../../assets/Ellipse 1.png'
import ContentLoader from 'react-content-loader';
import { getInitials } from '../../util/data';
const FollowCompanyFormComponent = props => {
  const {
    rootClassName,
    className,
    onSubmit,
    followCompany,
    followCompanyInProgress,
    handleUnfollow,
    currentUser,
    updateFollowerInProgress
  } = props;

  const classes = classNames(rootClassName, className);
  const pagination = followCompany?.pagination || {};
   const isCompany = currentUser && currentUser.id && currentUser.attributes.profile.publicData.accountType === "company";
   const MyLoader = () => (
    <ContentLoader height={220} width={800}>
    <rect x="0" y="0"   rx="4" ry="4" width="800" height="20" />
    <rect x="0" y="30"  rx="4" ry="4" width="800" height="20" />
    <rect x="0" y="60"  rx="4" ry="4" width="800" height="20" />
    <rect x="0" y="90"  rx="4" ry="4" width="800" height="20" />
    <rect x="0" y="120" rx="4" ry="4" width="800" height="20" />
    <rect x="0" y="150" rx="4" ry="4" width="800" height="20" />
  </ContentLoader>
  );
  return (
    <FinalForm
      onSubmit={{}}
      render={() => (
        <Form className={classes}>
          {
            (followCompanyInProgress || updateFollowerInProgress)
              ?  <MyLoader />
              : followCompany && followCompany?.users?.length > 0
                ? <>
                  <table className={css.transactionTable}>
                    <thead>
                      <tr>
                        <th> {isCompany ? "Follower " : "Company"}  Profile</th>
                        <th> {isCompany ? "Follower " : "Company"}  Name</th>
                        <th>  Followed Date</th>
                        <th>View</th>
                        {currentUser?.attributes?.profile?.publicData?.accountType == "fractionalPro" ?  <th>Action</th> : null}
                       
                      </tr>
                    </thead>
                    <tbody>
                      {followCompany?.users?.map((user, index) =>
                        <tr key={user?.id?.uuid}>
                          <td>
                            {user?.attributes ? (
                              <div className={css.profileImageWrapper}>
                                <ResponsiveImage
                                  rootClassName={css.profileImage}
                                  url={!user?.attributes?.profile?.publicData?.companyImage ? userImage  : null }
                                  image={user?.attributes?.profile?.publicData?.companyImage}
                                  alt={user?.attributes?.profile?.displayName}
                                  variants={['default']}
                                />  
                              </div>
                            ) : (
                              <div className={css.profileImagePlaceholder}>
                                <IconCard />
                              </div>
                            )}
                          </td>
                          <td>{getInitials(user?.attributes?.profile?.displayName)}</td>
                          <td>{new Date(followCompany?.followers[index]?.createdAt * 1000).toLocaleDateString()}</td>
                          <td >
                            <NamedLink
                              name="ListingPage"
                              className={css.txId}
                              params={{
                                id: isCompany &&
                                  typeof followCompany?.followers[index]?.fractionalProListingId === 'string' &&
                                  followCompany?.followers[index]?.fractionalProListingId
                                ? followCompany?.followers[index]?.fractionalProListingId
                                : followCompany?.followers[index]?.companyListingId, 
                                slug: ''
                              }}
                            >
                              <IconCard brand="eye" />
                            </NamedLink>
                          </td>
                          {currentUser?.attributes?.profile?.publicData?.accountType == "fractionalPro" ? <td><Button type='button' onClick={() => handleUnfollow(followCompany?.followers[index]?._id ,followCompany?.followers[index]?.companyId
                                )}>UnFollow</Button></td> : null}
                     
                        </tr>)
                        }
                    </tbody>
                  </table>

                  <PaginationLinks
                    className={css.pagination}
                    pageName="FollowCompanyPage"
                    pagePathParams={location.search}
                    pagination={pagination}
                  />
                </> : "No Followers Yet."}
        </Form>
      )}
    />
  );
};

FollowCompanyFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  desktopInputRoot: null,
  isMobile: false,
};

export default injectIntl(FollowCompanyFormComponent);
